var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BigNumber } from '@ethersproject/bignumber';
import { call } from '../../utils';
var Plugin = /** @class */ (function () {
    function Plugin() {
        this.author = 'lbeder';
        this.version = '0.1.0';
        this.name = 'Quorum';
    }
    /**
     * Returns the total voting power at specific snapshot
     */
    Plugin.prototype.getTotalVotingPower = function (web3, quorumOptions, snapshot) {
        return __awaiter(this, void 0, void 0, function () {
            var strategy, _a, address, methodABI, decimals, blockTag, totalVotingPower, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, , 7]);
                        strategy = quorumOptions.strategy;
                        _a = strategy;
                        switch (_a) {
                            case 'static': return [3 /*break*/, 1];
                            case 'balance': return [3 /*break*/, 2];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        {
                            return [2 /*return*/, quorumOptions.total];
                        }
                        _b.label = 2;
                    case 2:
                        address = quorumOptions.address, methodABI = quorumOptions.methodABI, decimals = quorumOptions.decimals;
                        blockTag = 
                        // @ts-ignore
                        snapshot === 'latest' ? snapshot : parseInt(snapshot);
                        return [4 /*yield*/, call(web3, [methodABI], [address, methodABI.name], { blockTag: blockTag })];
                    case 3:
                        totalVotingPower = _b.sent();
                        return [2 /*return*/, BigNumber.from(totalVotingPower)
                                .div(BigNumber.from(10).pow(decimals))
                                .toNumber()];
                    case 4: throw new Error("Unsupported quorum strategy: " + strategy);
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        e_1 = _b.sent();
                        throw new Error(e_1);
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return Plugin;
}());
export default Plugin;
